<template>
  <section class="showcase">
    <div class="showcase__titles">
      <AppEyelet :data="{ content: dataPage.eyelet }" />
      <AppLine :isSmall="true" />
      <AppTitle :data="{ content: dataPage.title }" class="c-title--light" />
      <AppLine :isSmall="true" />
      <AppTitle :data="{ content: dataPage.subtitle }" class="c-title--dark" />
      <AppLine :isSmall="true" />
    </div>

    <div class="showcase__images">
      <div
        v-for="(slide, i) in dataPage.images"
        :key="`slide-${i}`"
        class="showcase__image"
      >
        <AppPicture
          :data="{ src: slide.src, alt: '' }"
          :lazy="true"
        />
      </div>
    </div>

    <div class="showcase__button">
      <AppButton
        theme="light"
        :data="{ content: dataPage.button, url: `/${$route.params.city}/${type}` }"
      />
    </div>
  </section>
</template>

<script>
import AppLine from '@/components/AppLine.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppEyelet from '@/components/AppEyelet.vue';
import AppPicture from '@/components/AppPicture.vue';
import AppButton from '@/components/AppButton.vue';

import showcase from '@/assets/data/contents/showcase.json';

export default {
  name: 'AppShowcase',

  components: {
    AppLine,
    AppTitle,
    AppEyelet,
    AppPicture,
    AppButton,
  },

  data() {
    return {
      showcase,
    };
  },

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    dataPage() {
      return this.showcase[this.$route.params.city][this.type];
    },
  },
};
</script>

<style lang="scss" scoped>
.showcase {
  position: relative;
  width: 100%;

  &__titles {
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0px;
    z-index: 2;

    @include mq($until: ipadP) {
      position: relative;
    }
  }

  &__images {
    display: grid;
    grid-template-columns: repeat(13, 1fr);
    min-height: $unit-vh * 32;
    margin: $unit-vh * 3 0px;

    @include mq($until: ipadP) {
      display: block;
      min-height: auto;
    }

    @include mq(ipadP) {
      margin: $unit-vh * 2 0px;
      min-height: $unit-vh * 16;
    }

    @include mq(ds) {
      min-height: $unit-vh * 32;
    }

    .showcase__image {
      opacity: 0.5;

      &:nth-child(1) {
        grid-column: 1 / 4;
        align-self: end;

        .picture {
          @include aspect-ratio(19, 12);
        }

        @include mq($until: ipadP) {
          display: none;
        }
      }

      &:nth-child(2) {
        grid-column: 5 / 9;
        align-self: center;

        .picture {
          @include aspect-ratio(3, 4);
        }
      }

      &:nth-child(3) {
        grid-column: 10 / -1;
        align-self: end;

        .picture {
          @include aspect-ratio(1, 1);
        }

        @include mq($until: ipadP) {
          display: none;
        }
      }
    }
  }

  &__button {
    position: relative;
    width: 100%;
    margin-top: 20px;

    @include mq($until: ipadP) {
      text-align: center;
      margin-left: 0 !important;
    }

    @include mq($until: ipadL, $and: $is-touch-device) {
      margin-left: 20px;
    }

    @include mq(ipadP) {
      margin-top: 40px;
    }

    @include mq(ds) {
      margin-top: 100px;
    }
  }
}
</style>
